import { Button } from '@/components/ui/buttons/Button';
import Image from 'next/image';
import { ComponentProps } from 'react';
import vippsImage from './assets/pay_with_vipps.png';

/**
 * Props for the PayWithVipps button component
 */
type PayWithVippsProps = ComponentProps<typeof Button>;

/**
 * PayWithVipps button component that maintains all Button functionality
 * but displays the Vipps payment image
 */
export const PayWithVipps = (props: PayWithVippsProps) => {
  return (
    <Button
      {...props}
      className={`h-auto w-[300px] p-0 flex justify-center items-center ${props.className ?? ''}`}
    >
      <Image
        src={vippsImage}
        alt="Pay with Vipps"
        priority
        className="w-full h-full object-contain"
      />
    </Button>
  );
};

export default PayWithVipps;
